import * as Mod1 from "./initializers/spoiler-alert";
import * as Mod2 from "./lib/apply-spoiler";
import * as Mod3 from "./lib/discourse-markdown/spoiler-alert";
import * as Mod4 from "./lib/rich-editor-extension";
const compatModules = {
  "initializers/spoiler-alert": Mod1,
  "lib/apply-spoiler": Mod2,
  "lib/discourse-markdown/spoiler-alert": Mod3,
  "lib/rich-editor-extension": Mod4,
};
export { compatModules };
export default compatModules;
